import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Projeto } from '../models/projeto.model';
import { Page } from '../models/page.model';

@Injectable({
  providedIn: 'root'
})
export class ProjetoService extends BaseService<Projeto> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/projeto`, injector);
  }

  pesquisar(proposta: Projeto): Observable<Page<Projeto>> {
    return this.http.post<Page<Projeto>>(`${environment.API_PRICE}/projeto/pesquisar`, proposta);
  }

  getByClienteId(clienteId: number): Observable<Projeto[]> {
    return this.http.get<Projeto[]>(`${environment.API_PRICE}/projeto/getByClienteId/${clienteId}`);
  }
}
